import { forwardRef, type FC } from 'react';
import { Dialog, Slide } from '@mui/material';

import { FormPageHeader } from '#packages/web/layouts/page/header/form-page-header';
import { PageContent } from '#packages/web/layouts/page/page-content';
import { Fab } from '#packages/web/foundations/buttons/fab';

import { type AuditLightingTypeFormEntry } from '#packages/data-collection/models/audit-lighting-type-form';
import { type LightSourceGroup } from '#apps/client-web/pages/audit-form-lighting-type/audit-form-lighting-type-page.renderer';
import { LightingTypeListSelectable } from '#apps/client-web/features/audit-form-lighting-type/components/lighting-type-list-selectable';

const Transition = forwardRef(function Transition(
  props: React.ComponentProps<typeof Slide>,
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" enter exit ref={ref} {...props} />;
});

export type FixtureTypePickerDialogProps = {
  open: boolean;
  groups: LightSourceGroup[];
  onClose: () => void;
  onSelect: (entry: AuditLightingTypeFormEntry) => void;
  onEdit: (link: string) => void;
  onAdd: () => void;
};

export const FixtureTypePickerDialog: FC<FixtureTypePickerDialogProps> = ({
  open,
  groups,
  onClose,
  onSelect,
  onEdit,
  onAdd,
}) => (
  <Dialog
    open={open}
    fullScreen
    maxWidth="sm"
    slots={{ transition: Transition }}>
    <FormPageHeader
      onNavigationIconClick={onClose}
      title="Select Fixture Type"
    />
    <PageContent>
      <LightingTypeListSelectable
        groups={groups}
        onSelect={onSelect}
        onEdit={onEdit}
      />
    </PageContent>
    <Fab onClick={onAdd} tooltip="Add fixture type" />
  </Dialog>
);
